module.exports = __webpack_public_path__ + "static/media/U1-T2-2-2f.4be8efc1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/U1-T2-2-2f.svg
// module id = 545
// module chunks = 0